(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_search-input"] && !Shopify.designMode) return;
  try {
    function updateHeritageSearchRefinement() {
    const query = (new URLSearchParams(window.location.search).get('q') || '').trim();
    const plain = query.replaceAll('"', '').trim();
    const exact = query.startsWith('"') && query.endsWith('"');
    document.querySelectorAll('.heritage-search-refine').forEach((refinement) => {
      if (!plain.includes(' ')) { refinement.hidden = true; return; }
      refinement.hidden = false;
      const link = refinement.querySelector('a');
      if (!link) return;
      const target = new URL(link.href);
      target.searchParams.set('q', exact ? plain : '"' + plain + '"');
      target.searchParams.delete('page');
      link.href = target.href;
      link.textContent = exact ? refinement.dataset.broadenLabel : refinement.dataset.exactLabel;
      let status = refinement.querySelector('span');
      if (!status) { status = document.createElement('span'); refinement.prepend(status); }
      status.textContent = exact ? refinement.dataset.activeLabel : '';
      status.hidden = !exact;
    });
  }
  updateHeritageSearchRefinement();
  document.addEventListener('shopify:section:load', updateHeritageSearchRefinement);
  } catch(e) { console.error(e); }
})();

})();
